import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { RootState } from 'reducers';
import { AdyenConfig } from 'containers/Forms/Settings/views/Payment/components/Adyen/types';

import { getCafaEntry } from '../../reducers/cafaConfigs';
import { INTEGRATION_TYPES, INTEGRATIONS } from '../../constants/CAFA';

import { askForAdditionalDataPerType } from './utils/additionalDataPrompt';

const MANUAL_ENTRY = {
  OPTIONS: {
    NEVER: 'never',
    ALWAYS: 'always',
    ASK: 'ask',
  },
  PARAMS: {
    ALLOWED: {
      noCardPayment: true,
    },
    DISALLOWED: {
      noCardPayment: false,
    },
  },
};
/**
 * Checks if Adyen Configuration has been configured to use Manual Entry Mode
 *
 * If the config has a origEntryMode configuration value
 * * always - set EntryMode to manual - { noCardPayment: true }
 * * never - don't do anything - return { noCardPayment: false }
 * * ask - ask the user via popup for their input and return one of the above based on their selection
 */

export function getManualEntryModeParams() {
  return async (
    dispatch: ThunkDispatch<RootState, unknown, Action>,
    getState: () => RootState,
  ) => {
    const { value: config } =
      getCafaEntry<'payment', 'adyen', AdyenConfig>(
        INTEGRATIONS.payment.adyen,
        INTEGRATION_TYPES.payment,
      )(getState()) || {};
    const { OPTIONS, PARAMS } = MANUAL_ENTRY;

    switch (config?.manualEntry) {
      case OPTIONS.ALWAYS:
        return Promise.resolve(PARAMS.ALLOWED);
      case OPTIONS.ASK:
        return dispatch(
          askForAdditionalDataPerType('manualEntry'),
        ).then(isAllowed => (isAllowed ? PARAMS.ALLOWED : PARAMS.DISALLOWED));
      case OPTIONS.NEVER:
      default:
        return Promise.resolve(PARAMS.DISALLOWED);
    }
  };
}
